import React from 'react';
import AOS from 'aos';

//Defile circle images
const Circle = () =>{
    AOS.init();
    return(
        <div>
        <img className="home_circle circle1" src="../../assets/images/circle31.png" data-aos="fade-up" data-aos-delay="600" data-aos-once="true"/>
        <img className="home_circle circle2" src="../../assets/images/circle32.png" data-aos="fade-up" data-aos-delay="1000" data-aos-once="false"/>
        <img className="home_circle circle3" src="../../assets/images/circle33.png" data-aos="fade-up" data-aos-delay="1300" data-aos-once="false"/>
        <img className="home_circle circle4" src="../../assets/images/circle34.png" data-aos="fade-up" data-aos-delay="1600" data-aos-once="false"/>
    </div>
    )
}
export default Circle;


// WEBPACK FOOTER //
// ./web/components/home/circle.js